module.exports = __webpack_public_path__ + "10c53e1e10f48a28a185f144e9da6a5d.MP3";